// Wrapper for reactstrap components to handle import issues with Vite
// All exports use 'Reactstrap' prefix to avoid conflicts with custom components
import * as Reactstrap from 'reactstrap';

export const ReactstrapNavbar = Reactstrap.Navbar || Reactstrap.default?.Navbar || function NavbarFallback({ children, className, ...props }) {
  return <nav className={className} {...props}>{children}</nav>;
};

export const ReactstrapNavItem = Reactstrap.NavItem || Reactstrap.default?.NavItem;
export const ReactstrapNavLink = Reactstrap.NavLink || Reactstrap.default?.NavLink;
export const ReactstrapButton = Reactstrap.Button || Reactstrap.default?.Button;
export const ReactstrapUncontrolledTooltip = Reactstrap.UncontrolledTooltip || Reactstrap.default?.UncontrolledTooltip;
export const ReactstrapUncontrolledDropdown = Reactstrap.UncontrolledDropdown || Reactstrap.default?.UncontrolledDropdown;
export const ReactstrapBadge = Reactstrap.Badge || Reactstrap.default?.Badge;
export const ReactstrapCard = Reactstrap.Card || Reactstrap.default?.Card;
export const ReactstrapCardBody = Reactstrap.CardBody || Reactstrap.default?.CardBody;
export const ReactstrapCardHeader = Reactstrap.CardHeader || Reactstrap.default?.CardHeader;
export const ReactstrapCardText = Reactstrap.CardText || Reactstrap.default?.CardText;
export const ReactstrapCardTitle = Reactstrap.CardTitle || Reactstrap.default?.CardTitle;
export const ReactstrapCardSubtitle = Reactstrap.CardSubtitle || Reactstrap.default?.CardSubtitle;
export const ReactstrapCol = Reactstrap.Col || Reactstrap.default?.Col;
export const ReactstrapRow = Reactstrap.Row || Reactstrap.default?.Row;
export const ReactstrapInput = Reactstrap.Input || Reactstrap.default?.Input;
export const ReactstrapLabel = Reactstrap.Label || Reactstrap.default?.Label;
export const ReactstrapInputGroup = Reactstrap.InputGroup || Reactstrap.default?.InputGroup;
export const ReactstrapInputGroupText = Reactstrap.InputGroupText || Reactstrap.default?.InputGroupText;
export const ReactstrapCollapse = Reactstrap.Collapse || Reactstrap.default?.Collapse;
export const ReactstrapModal = Reactstrap.Modal || Reactstrap.default?.Modal;
export const ReactstrapModalBody = Reactstrap.ModalBody || Reactstrap.default?.ModalBody;
export const ReactstrapModalHeader = Reactstrap.ModalHeader || Reactstrap.default?.ModalHeader;
export const ReactstrapAlert = Reactstrap.Alert || Reactstrap.default?.Alert;
export const ReactstrapDropdown = Reactstrap.Dropdown || Reactstrap.default?.Dropdown;
export const ReactstrapDropdownMenu = Reactstrap.DropdownMenu || Reactstrap.default?.DropdownMenu;
export const ReactstrapDropdownItem = Reactstrap.DropdownItem || Reactstrap.default?.DropdownItem;
export const ReactstrapDropdownToggle = Reactstrap.DropdownToggle || Reactstrap.default?.DropdownToggle;
export const ReactstrapNav = Reactstrap.Nav || Reactstrap.default?.Nav;
export const ReactstrapTabContent = Reactstrap.TabContent || Reactstrap.default?.TabContent;
export const ReactstrapTabPane = Reactstrap.TabPane || Reactstrap.default?.TabPane;
export const ReactstrapProgress = Reactstrap.Progress || Reactstrap.default?.Progress;
export const ReactstrapTable = Reactstrap.Table || Reactstrap.default?.Table;
export const ReactstrapToast = Reactstrap.Toast || Reactstrap.default?.Toast;
export const ReactstrapToastBody = Reactstrap.ToastBody || Reactstrap.default?.ToastBody;
export const ReactstrapToastHeader = Reactstrap.ToastHeader || Reactstrap.default?.ToastHeader;
export const ReactstrapForm = Reactstrap.Form || Reactstrap.default?.Form;
